import React from "react";

class LanguageToggleErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

const LanguageToggleLazy = React.lazy(() => import("./LanguageToggle"));

export default function LanguageToggleSafe() {
  return (
    <LanguageToggleErrorBoundary>
      <React.Suspense fallback={<div className="ftg-lang-toggle" />}>
        <LanguageToggleLazy />
      </React.Suspense>
    </LanguageToggleErrorBoundary>
  );
}
